import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemplateIndicadorService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');
  constructor(
    private http: HttpClient,
  ) { }
  //asociar un indicador a la plantilla sin formula 
  public setTempIndSF(tmpid, indid): Observable<any>{
    const p = {
      templateid: tmpid,
      indicadorid: indid,
    }
    const body = JSON.stringify(p);
    const apiURL = this.apiURL + 'api/tempind/create';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  //se crea la formula asociado al indicador asociado a la plantilla
  public setTempIndF(tmpid, indid): Observable<any>{
    const p = {
      templateid: tmpid,
      indicadorid: indid,
    }
    const body = JSON.stringify(p);
    const apiURL = this.apiURL + 'api/tempind/create';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public getFormulaIndTmp(indid: number, tmpid:Number): Observable<any>{
    const p = {
      templateid: tmpid,
      indicadorid: indid,
    }
    const body = JSON.stringify(p);
    const apiURL = this.apiURL + 'api/tempind/list';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
}
